export default __webpack_public_path__ + "static/es-ga-b5043ad2a3624b8accf187f3d62e26d0.svg";